import React from 'react';

import lang from '../../../../../lib/language';

import { useIsMobile } from '../../../../../hooks';
import { GoBackButton } from '../../../../index';
import TermsAndConditions from '../../../../TermsAndConditions/TermsAndConditions';

import styles from './Documents.module.scss';

const Documents = () => {
  const isMobile = useIsMobile();
  return (
    <div className={styles.wrapper}>
      {!isMobile && <GoBackButton />}
      <div className={styles.wrapperDocument}>
        <div className={styles.headerText}>
          <h3>{lang.mobileProfileDocuments()}</h3>
        </div>
        <div className={styles.wrapperNavigation}>
          <TermsAndConditions />
        </div>
      </div>
    </div>
  );
};

export default Documents;
